module.exports = __webpack_public_path__ + "img/order6.a8a159d3.png";